import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import clientService from "../services/clientService";
import entrepotservice from "../services/entrepotService";
import userService from "../services/userService";

const initialState = {
    users: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 5

};

const userSlice = createModule({
    name: 'users',
    initialState,
    reducers: {
        list: (state) => {
            state.loading = true;
        },
        addUser: (state) => {
            state.loading = true;
        },
        updateUser: (state) => {
            state.loading = true;
        },
        activateUser: (state) => {
            state.loading = true;
        },

        deactivateUser: (state) => {
            state.loading = true;
        },

        /* ============================================
           RESET PASSWORD
        ============================================ */
        resetPassword: (state) => {
            state.loading = true;
        },

        fetchedData: (state, payload) => {
            state.loading = false;
            state.users = payload.content || [];
        },

        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },

    },
    sagas: (A) => ({
        *[A.list]() {
            try {
                const { data } = yield call(userService.list);
                console.log(data)
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addUser]({ payload }) {
            try {
                const { data } = yield call(userService.add, payload.data);
                yield put(A.finishFetching());
                yield put(A.list());
                yield call(payload.onSuccess(data.body));
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
            }
        },
        *[A.updateUser]({ payload }) {
            try {
                const { data } = yield call(userService.update, payload.id, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        // ========= DELETE =========
        *[A.deleteUser]({ payload }) {
            try {
                yield call(userService.delete, payload.id);
                yield put(A.list());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
            }
        },
        *[A.activateUser]({ payload }) {
            try {
                yield call(userService.activate, payload.id);
                yield put(A.list()); // refresh list
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError);
            }
        },
        *[A.deactivateUser]({ payload }) {
            try {
                yield call(userService.deactivate, payload.id);
                yield put(A.list());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError);
            }
        },
        *[A.resetPassword]({ payload }) {
            try {
                yield call(userService.resetPassword, payload.id, payload.newPassword);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError);
            }
        },

    }),
});

export default userSlice;
export const userActions = userSlice.actions;